import * as React from 'react'
import { createComponent } from '@cloudflare/style-container'
import { TPreviewProps } from '../lib/FiddleService'

export const FiddleResultLoading = createComponent(() => ({
  display: 'flex',
  flex: 1,
  width: '100%',
}))

export interface IFiddleResultProps {
  isActive: boolean
  getPreviewId: (props: TPreviewProps) => string
  getPreviewUrl: (props: TPreviewProps) => string
  preview: TPreviewProps
}

export interface IFiddleResultState {
  previewId: string
}

export class FiddleResult extends React.Component<
  IFiddleResultProps,
  IFiddleResultState
> {
  getDerivedState(props: IFiddleResultProps): IFiddleResultState {
    return {
      previewId: props.getPreviewId(props.preview),
    }
  }

  constructor(props: IFiddleResultProps) {
    super(props)
    this.state = this.getDerivedState(props)
  }

  componentWillReceiveProps(props: IFiddleResultProps) {
    if (props.isActive) {
      this.setState(this.getDerivedState(props))
    }
  }

  shouldComponentUpdate(props: IFiddleResultProps, state: IFiddleResultState) {
    if (!props.isActive) return false

    if (!this.props.isActive) {
      // if wasn't previously active, update on request mismatch
      return state.previewId !== this.state.previewId
    } else {
      // if was already active, don't update until explicitly asked
      return props.preview.updateCount !== this.props.preview.updateCount
    }
  }

  render() {
    return (
      <iframe
        src={this.props.getPreviewUrl(this.props.preview)}
        sandbox="allow-forms allow-modals allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
        style={{
          flex: '1',
          border: 'none',
          width: '100%',
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FiddleResult.tsx